import React from 'react';
import Checkbox from 'material-ui/Checkbox';

export const AnswerCheckbox = ({
  option,
  answer,
  onQuestionAnswerEdit,
  showKeyLearning,
  quiz,
  index,
}) => {
  const answerKeyIndex = (answer[quiz.id] || []).map(answer => Object.keys(answer)[0]).indexOf(`answer_${index}`);
  const isSelected = answerKeyIndex !== -1;
  const answerValue = isSelected && answer[quiz.id][answerKeyIndex] ? answer[quiz.id][answerKeyIndex][`answer_${index}`] : '';
  const isCorrectAnswer = option.correct === answerValue && showKeyLearning ? (answerValue === 'true' ? 'correct' : 'incorrect') : '';

  return (
    <Checkbox
      label={option.body}
      checked={isSelected} //=== option.correct}
      value={option.correct}
      id={quiz.id}
      onCheck={(e) => onQuestionAnswerEdit(e, index)}
      disabled={showKeyLearning}
      className={isCorrectAnswer}
    />
  );
}



// WEBPACK FOOTER //
// ./src/modules/topic/components/AnswerCheckbox.js